import axios from 'axios';
import getBaseApi from '@luna-protocol/core/src/utils/getBaseApi';
import { useMutation } from 'react-query';
import { useAppStore } from '../useAppStore.ts';

interface CommitApplicationRequest {
  social_security_number: string;
}

const usePostCommitApplication = () => {
  const loanApplicationID = useAppStore(state => state.loanApplicationID);

  const mutation = useMutation((data: CommitApplicationRequest) => {
    return axios.post(`${getBaseApi()}/consumer/application/${loanApplicationID}/commit`, data, {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('user_token')}` },
    });
  });

  return {
    commitApplication: mutation.mutate,
    ...mutation,
  };
};
export { usePostCommitApplication };
